export default class Coordinate {
    public degree?: number;
    public minute?: number;
    public second?: number;
}
